import { Toast, type ToastComponent } from '@opallabs/lapidary'

type UploadFailedToastProps = {
  invalid: number
  total: number
}

export const UploadFailedToast: ToastComponent<UploadFailedToastProps> = ({
  invalid,
  total,
  ...toastProps
}) => {
  const count = invalid !== total ? `${invalid}/${total}` : 'All'

  return (
    <Toast
      {...toastProps}
      message={`${count} files failed to upload. Please try again later.`}
      title={`Failed to Upload`}
    />
  )
}
